import { ModuleWithProviders, NgModule } from '@angular/core';
import { SW_CONFIG } from './injection-tokens';
import { SwConfig } from './types';
import { UpdatesHandlerService } from './updates-handler';
import { UpdatesListenerService } from './updates-listener.service';
import { UpdatesService } from './updates.service';

@NgModule({})
export class ServiceWorkerModule {
  static use(config: SwConfig): ModuleWithProviders<ServiceWorkerModule> {
    const resolvedConfig: SwConfig = {
      ...config,
      pollingInterval: config.pollingInterval || 60,
    };

    return {
      ngModule: ServiceWorkerModule,
      providers: [
        { provide: SW_CONFIG, useValue: resolvedConfig },
        UpdatesListenerService,
        UpdatesHandlerService,
        UpdatesService
      ],
    };
  }

  constructor(updatesService: UpdatesListenerService) {
    updatesService.subscribeToUpdates();
  }
}
